import { isNullOrUndefined } from "../commons";

// Global unhandled rejection handler
process.on("unhandledRejection", (reason, promise) => {
  console.log("Unhandled Rejection at:", promise, "reason:", reason);
});

/**
 * Get Pricing Data helps in retrieving the promo pricing data.
 * @param {string[]} cmJsonUrl - pricing segment urls that is being used
 * @param {Function} setPricingState - state setter function from React useState
 */
export const getPricingData = async (cmJsonUrl, setPricingState) => {
  let cm_json = {};
  console.log(
    global?.experiment,
    global?.bucket,
    "experimentation test log from getPricingData"
  );
  let cmJsonExpValue = isCampaignAvailable()
    ? `${global?.experiment}`
    : "default";
  let cmJsonBucketValue = isCampaignAvailable()
    ? `${global?.bucket}`
    : "default";

  try {
    const responses = await Promise.all(cmJsonUrl.map((val) => fetch(val)));
    const dataPromises = responses.map((response) => response.json());
    const dataArray = await Promise.all(dataPromises);
    const arrayToProcess = dataArray.length === 0 ? [{}] : dataArray;
    arrayToProcess.forEach((data) => {
      cm_json = {
        campaigns: {
          ...cm_json.campaigns,
          ...data.campaigns?.[cmJsonExpValue][cmJsonBucketValue]
        },
        bundles: {
          ...cm_json.bundles,
          ...data.bundles?.[cmJsonExpValue][cmJsonBucketValue]
        },
        offerDefinitions: {
          ...cm_json.offerDefinitions,
          ...data.offerDefinitions
        }
      };
    });

    const productToOfferIdMap = {};
    await transformPricingJsonToOneLevelObject(productToOfferIdMap, cm_json);

    setPricingState({
      pricingJson: cm_json,
      mappedProductsId: productToOfferIdMap,
      error: null,
      isLoading: false
    });
  } catch (err) {
    reportError(
      `[Rendering Prices];EVENT_NAME=JSON_LOAD_TRANSFORM_ERROR;shouldLoadDynamicPrices= Error while loading/transforming pricing json - ${err.stack}`
    );
    setPricingState({
      pricingJson: {},
      mappedProductsId: {},
      error: err,
      isLoading: false
    });
  }
};

/**
 * Transform Pricing nested json object to one level object
 * @param {Object} map - output empty  map
 * @param {Object} pricingJson - Pricing Json from CM
 * @returns {Object} map - Transformed json { product1: offerId1.. }
 * * */
const transformPricingJsonToOneLevelObject = async (map, pricingJson) => {
  if (!pricingJson || !pricingJson.campaigns) {
    throw new Error(
      `[Rendering Prices] Error loading dynamic prices. Pricing Json and/or campaigns not loaded correctly on the page`
    );
  } else {
    const pricingJsonObj = {
      ...pricingJson.campaigns,
      ...pricingJson.bundles
    };
    map = await transformPricingHelper(map, pricingJsonObj, "");
  }
  return map;
};

/**
  * Helper function to transform prices json recursively
  * @returns {Object} map of one leveled key value pair
  * e.g. {
    PR_CORE.MONTHLY.PAID: "20019766",
    PAYROLL.PR_PREMIUM.MONTHLY.TRIAL: "20019759"
    QBLIVE_ONETIME.QBLIVE_EXPERT_SERVICES.ONE TIME.PAID: "20018808"
    ....
  }
  * */
const transformPricingHelper = (map, obj, constructedKey) => {
  const keys = Object.keys(obj);
  if (keys && keys.length === 1 && keys[0] === "offer_id") {
    // remove period from the beginning of the key and set offer id as value
    map[constructedKey.substring(1)] = obj[keys[0]];
  } else {
    keys.map((currKey) => {
      const currConstructedKey = `${constructedKey}.${currKey}`;
      map = transformPricingHelper(map, obj[currKey], currConstructedKey);
    });
  }
  return map;
};

/**
 * Logs errors to the splunk and the console
 * @param {String} message - defines the error message from the stack
 */
const reportError = (message) => {
  console.error(message);
  let csLog = window.csLog;
  if (typeof csLog === "function") {
    csLog("error", message);
  }
};

/**
 * Checks if the experiment or bucket name is defined for the campaign manager promotions.
 */
export const isCampaignAvailable = () => {
  if (
    typeof global?.experiment !== "undefined" &&
    typeof global?.bucket !== "undefined" &&
    !isNullOrUndefined(global?.experiment) &&
    !isNullOrUndefined(global?.bucket)
  ) {
    return true;
  }
  console.log(
    "[Rendering Prices] ; Experiment and/or bucket info not available for current user"
  );
  return false;
};
